import api from 'services/api';
import { checkId } from 'services/common';
import { GET, POST, PUT, DELETE, projectRoutes } from 'constants/api';

const checkProjectId = projectId => {
  checkId(projectId, 'Project id is missing');
};

export const getProjects = () =>
  api({
    method: GET,
    url: projectRoutes.GET_PROJECTS,
  });

export const getProjectById = projectId => {
  checkProjectId(projectId);
  return api({
    method: GET,
    url: `${projectRoutes.GET_PROJECTS}${projectId}`,
  });
};

export const addProject = data =>
  api({
    method: POST,
    url: projectRoutes.ADD_PROJECT,
    data,
  });

export const editProject = data => {
  checkProjectId(data.id);
  return api({
    method: PUT,
    url: `${projectRoutes.EDIT_PROJECT}${data.id}`,
    data,
  });
};

export const deleteProject = projectId => {
  checkProjectId(projectId);
  return api({
    method: DELETE,
    url: `${projectRoutes.DELETE_PROJECT}${projectId}`,
  });
};
